/** Shared classification for staff-session bootstrap failures. */
export function isStaffSessionAuthFailure(error) {
  const status = Number(error?.status ?? error?.httpStatus);
  return status === 401 || status === 403;
}

export function isStaffSessionUnauthenticated(error) {
  return Number(error?.status ?? error?.httpStatus) === 401;
}

export function staffSessionFailureAction(error) {
  return isStaffSessionAuthFailure(error) ? "reauth" : "retry";
}

export function loadMirroredSessionToken(primaryKey, mirrorKey) {
  let loggedOut = false;
  try {
    loggedOut = Boolean(localStorage.getItem(`${primaryKey}_logout`));
  } catch {
    /* private mode */
  }
  if (loggedOut) {
    try {
      localStorage.removeItem(primaryKey);
    } catch {
      /* private mode */
    }
    try {
      sessionStorage.removeItem(mirrorKey);
    } catch {
      /* private mode */
    }
    return "";
  }

  let primary = "";
  try {
    primary = (localStorage.getItem(primaryKey) || "").trim();
  } catch {
    /* iOS PWA cold-start storage read */
  }
  if (primary) return primary;
  let mirror = "";
  try {
    mirror = (sessionStorage.getItem(mirrorKey) || "").trim();
  } catch {
    /* private mode */
  }
  if (mirror) {
    try {
      localStorage.setItem(primaryKey, mirror);
    } catch {
      /* primary storage remains unavailable */
    }
    return mirror;
  }
  return "";
}

export function saveMirroredSessionToken(primaryKey, mirrorKey, token) {
  if (token) {
    try {
      localStorage.setItem(primaryKey, token);
    } catch {
      /* private mode */
    }
    try {
      localStorage.removeItem(`${primaryKey}_logout`);
    } catch {
      /* private mode */
    }
  } else {
    try {
      localStorage.removeItem(primaryKey);
    } catch {
      /* private mode */
    }
    try {
      localStorage.setItem(`${primaryKey}_logout`, "1");
    } catch {
      /* private mode */
    }
  }
  try {
    if (token) sessionStorage.setItem(mirrorKey, token);
    else sessionStorage.removeItem(mirrorKey);
  } catch {
    /* private mode */
  }
}

/** Preserve HTTP status so callers can distinguish auth loss from outages. */
export function staffSessionApiError(message, status) {
  const error = new Error(message || "Staff session request failed");
  error.status = Number(status) || 0;
  return error;
}
